// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionDescription_root__1IVq9","description":"SectionDescription_description__1JVBn"};